import { render, staticRenderFns } from "./videoCourse.vue?vue&type=template&id=6861f6a2&scoped=true&"
import script from "./videoCourse.vue?vue&type=script&lang=js&"
export * from "./videoCourse.vue?vue&type=script&lang=js&"
import style0 from "./videoCourse.vue?vue&type=style&index=0&id=6861f6a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6861f6a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-product-tool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6861f6a2')) {
      api.createRecord('6861f6a2', component.options)
    } else {
      api.reload('6861f6a2', component.options)
    }
    module.hot.accept("./videoCourse.vue?vue&type=template&id=6861f6a2&scoped=true&", function () {
      api.rerender('6861f6a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/videoCourse.vue"
export default component.exports